module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_1234_atoll_blue.7850c739.jpg";